import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

export default function Body(props) {

  let { body, escapeHtml } = props
  if (!body) return null

  return (
    <Row>
      <Col lg={12}>
        <div className="markdown-body">
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>
            {body}
          </ReactMarkdown>
        </div>
      </Col>
    </Row>
  )
}
